var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chain)?_c('v-btn',{staticClass:"text-capitalize",attrs:{"depressed":"","small":"","color":"#E4E6EB"},on:{"click":_vm.show}},[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v("mdi-store")]),_c('span',[_vm._v("Multiple Locations")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }